<script lang="ts">
  import navigation from '../plugins/routes'

  const year = new Date().getFullYear()
</script>

<footer class="px-8 py-4 mt-24 flex text-sm items-center justify-between whitespace-nowrap flex-wrap	bg-slate-800 text-white">
  <span class="p-2">© EUROCONTACT {year}</span>

  <ul class="flex items-center justify-between uppercase flex-wrap">
    {#each navigation as { name, path }, i}
      <li>
        <a class="block p-2"
          href={path}
        >
          {name}
        </a>
      </li>
    {/each}
  </ul>
  <span class="p-2">POJEMNIKISPOZYWCZE.PL</span>
</footer>

